import {VStack} from 'platform/foundation';
import styled from 'styled-components';

import {PROBE_ROW_COUNTS} from './constants/probeRowCounts';
import {MeasuredProbe} from './MeasuredProbe';
import {VehicleMotMeasurementSetters} from './types/VehicleMotMeasurementSetters';
import {VehicleWarehouseAdaptiveMotProps} from './types/VehicleWarehouseAdaptiveMotProps';
import {VehicleMotSectionProbe} from './VehicleMotSectionProbe';

interface VehicleWarehouseMotProbesProps extends VehicleWarehouseAdaptiveMotProps {
  rowLayoutKey: string;
  setters: VehicleMotMeasurementSetters;
}

interface StyledSectionProbesProps {
  $isSideBySide: boolean;
}

export function VehicleWarehouseMotProbes(props: VehicleWarehouseMotProbesProps) {
  return (
    <StyledProbeOuter inert aria-hidden>
      <MeasuredProbe
        kind="aggregate"
        resetKey={props.rowLayoutKey}
        onHeight={props.setters.setAggregateMeasurement}
      >
        {props.renderAggregate(true)}
      </MeasuredProbe>
      <MeasuredProbe
        kind="stacked-gap"
        resetKey={props.rowLayoutKey}
        onHeight={props.setters.setStackedGapMeasurement}
      >
        <VStack spacing={4}>
          <span />
          <span />
        </VStack>
      </MeasuredProbe>
      <StyledSectionProbes $isSideBySide={props.size === 'wide'}>
        {PROBE_ROW_COUNTS.flatMap((rowCount) => [
          <VehicleMotSectionProbe
            key={`expired-${rowCount}`}
            category="expired"
            rowCount={rowCount}
            count={props.expiredCount}
            rows={props.expiredRows}
            resetKey={props.rowLayoutKey}
            renderSection={props.renderSection}
            setMeasurements={props.setters.setExpiredMeasurements}
          />,
          <VehicleMotSectionProbe
            key={`expiring-${rowCount}`}
            category="expiring"
            rowCount={rowCount}
            count={props.expiringCount}
            rows={props.expiringRows}
            resetKey={props.rowLayoutKey}
            renderSection={props.renderSection}
            setMeasurements={props.setters.setExpiringMeasurements}
          />,
        ])}
      </StyledSectionProbes>
    </StyledProbeOuter>
  );
}

const StyledProbeOuter = styled.div`
  position: absolute;
  inset: 0;
  height: 0;
  contain: size;
  overflow: clip;
  visibility: hidden;
  pointer-events: none;
`;

const StyledSectionProbes = styled.div<StyledSectionProbesProps>`
  display: grid;
  grid-template-columns: repeat(${({$isSideBySide}) => ($isSideBySide ? 2 : 1)}, minmax(0, 1fr));
  column-gap: ${({theme}) => theme.getSize(4)};
  align-items: start;
`;
